import { RefObject } from 'react'
import { LocalChatMessage } from './types'
import { parseStructuredResponse } from './parseStructuredResponse'
import StructuredMessageRenderer from './StructuredMessageRenderer'
import ThinkingIndicator from './ThinkingIndicator'

type ChatAssistantMessagesListProps = {
    messages: ReadonlyArray<LocalChatMessage>
    isLoading: boolean
    isPreparing: boolean
    onContentReferenceClick?: (contentId: number) => void
    messagesEndRef?: RefObject<HTMLDivElement>
}

export default function ChatAssistantMessagesList({
    messages,
    isLoading,
    isPreparing,
    onContentReferenceClick,
    messagesEndRef
}: ChatAssistantMessagesListProps) {
    return (
        <>
            {messages.map((message) => {
                const isUser = message.role === 'user'
                return (
                    <div
                        key={message.id}
                        className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}
                    >
                        <div
                            className={`max-w-[85%] rounded-2xl px-5 py-4 shadow-sm ${
                                isUser
                                    ? 'bg-primary-600 text-white'
                                    : 'bg-white text-gray-900 border border-gray-200'
                            }`}
                        >
                            {isUser ? (
                                <p className="whitespace-pre-wrap text-sm leading-relaxed">
                                    {message.content}
                                </p>
                            ) : (
                                <StructuredMessageRenderer
                                    message={parseStructuredResponse(message.content)}
                                    onContentReferenceClick={onContentReferenceClick}
                                />
                            )}
                        </div>
                    </div>
                )
            })}

            {isLoading && !isPreparing && (
                <div className="flex justify-start">
                    <div className="flex max-w-[85%] items-center rounded-2xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
                        <ThinkingIndicator />
                    </div>
                </div>
            )}

            {/* Scroll anchor for auto-scrolling to newest message */}
            <div ref={messagesEndRef} />
        </>
    )
}
